export const CALENDAR_ADMIN_RESET = 'CALENDAR_ADMIN_RESET';

export const CALENDAR_GET_LIST_INIT = 'CALENDAR_GET_LIST_INIT';
export const CALENDAR_GET_LIST_SUCCESS = 'CALENDAR_GET_LIST_SUCCESS';
export const CALENDAR_GET_LIST_FAILURE = 'CALENDAR_GET_LIST_FAILURE';

export const CALENDAR_GET_RULES_LIST_INIT = 'CALENDAR_GET_RULES_LIST_INIT';
export const CALENDAR_GET_RULES_LIST_SUCCESS = 'CALENDAR_GET_RULES_LIST_SUCCESS';
export const CALENDAR_GET_RULES_LIST_FAILURE = 'CALENDAR_GET_RULES_LIST_FAILURE';

export const CALENDAR_ADMIN_SAVE_CALENDAR_INIT = 'CALENDAR_ADMIN_SAVE_CALENDAR_INIT';
export const CALENDAR_ADMIN_SAVE_CALENDAR_SUCCESS = 'CALENDAR_ADMIN_SAVE_CALENDAR_SUCCESS';
export const CALENDAR_ADMIN_SAVE_CALENDAR_FAILURE = 'CALENDAR_ADMIN_SAVE_CALENDAR_FAILURE';
export const CALENDAR_ADMIN_SAVE_CALENDAR_DATA_BY_KEY = 'CALENDAR_ADMIN_SAVE_CALENDAR_DATA_BY_KEY';
export const CALENDAR_ADMIN_SAVE_CALENDAR_RESET = 'CALENDAR_ADMIN_SAVE_CALENDAR_RESET';

export const CALENDAR_ADMIN_SAVE_RULE_INIT = 'CALENDAR_ADMIN_SAVE_RULE_INIT';
export const CALENDAR_ADMIN_SAVE_RULE_SUCCESS = 'CALENDAR_ADMIN_SAVE_RULE_SUCCESS';
export const CALENDAR_ADMIN_SAVE_RULE_FAILURE = 'CALENDAR_ADMIN_SAVE_RULE_FAILURE';
export const CALENDAR_ADMIN_SAVE_RULE_DATA_BY_KEY = 'CALENDAR_ADMIN_SAVE_RULE_DATA_BY_KEY';
export const CALENDAR_ADMIN_SAVE_RULE_RESET = 'CALENDAR_ADMIN_SAVE_RULE_RESET';

export const CALENDAR_ADMIN_GET_LABORAL_DAYS_INIT = 'CALENDAR_ADMIN_GET_LABORAL_DAYS_INIT';
export const CALENDAR_ADMIN_GET_LABORAL_DAYS_SUCCESS = 'CALENDAR_ADMIN_GET_LABORAL_DAYS_SUCCESS';
export const CALENDAR_ADMIN_GET_LABORAL_DAYS_FAILURE = 'CALENDAR_ADMIN_GET_LABORAL_DAYS_FAILURE';

export const CALENDAR_DELETE_PREPARE_INIT = 'CALENDAR_DELETE_PREPARE_INIT';
export const CALENDAR_DELETE_INIT = 'CALENDAR_DELETE_INIT';
export const CALENDAR_DELETE_SUCCESS = 'CALENDAR_DELETE_SUCCESS';
export const CALENDAR_DELETE_FAILURE = 'CALENDAR_DELETE_FAILURE';

export const CALENDAR_RULE_DELETE_PREPARE_INIT = 'CALENDAR_RULE_DELETE_PREPARE_INIT';
export const CALENDAR_RULE_DELETE_INIT = 'CALENDAR_RULE_DELETE_INIT';
export const CALENDAR_RULE_DELETE_SUCCESS = 'CALENDAR_RULE_DELETE_SUCCESS';
export const CALENDAR_RULE_DELETE_FAILURE = 'CALENDAR_RULE_DELETE_FAILURE';



// WEBPACK FOOTER //
// ./source/client/actions/calendarAdmin/types.js